import { render, staticRenderFns } from "./EmptyPaperIcon.vue?vue&type=template&id=8c8cb8d2&"
import script from "./EmptyPaperIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyPaperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports